module.exports = __webpack_public_path__ + "img/basic_service.0cbfbe00.jpg";